import ReactOnRails from 'react-on-rails/client';
import SeoState from '../../bundles/SeoState/components/SeoState.client.jsx';

ReactOnRails.register({SeoState});